export default {
  region: process.env.VUE_APP_AWS_REGION,
  IdentityPoolId: process.env.VUE_APP_IDENTITY_POOL,
  UserPoolId: process.env.VUE_APP_USER_POOL,
  ClientId: process.env.VUE_APP_CLIENT,
  CognitoIdp: `cognito-idp.${process.env.VUE_APP_AWS_REGION}.amazonaws.com/${process.env.VUE_APP_USER_POOL}`,
};
